import { getEnv } from '../env'
import { LocalStorageItem } from '../localStorage'
import { randomString } from '../random'

const _DEFAULT_CLIENT_NAME = getEnv('deviceApiWebClientName')
const _DEFAULT_CLIENT_VERSION = getEnv('deviceApiWebClientVersion')
const _DEFAULT_IS_DEFAULT_BROWSER = String(false)
const _DEFAULT_CLIENT_LOCALIZATION = getEnv('deviceApiWebClientLocalization')
const _DEFAULT_KILOBYTES_SAVED_TODAY = String(0)
const _DEFAULT_HAID = randomString()
const _DEFAULT_HUID = randomString()

interface DeviceApiWebValuesStorage {
  clientName: LocalStorageItem
  walletAddress: LocalStorageItem
  isDefaultBrowser: LocalStorageItem
  clientLocalization: LocalStorageItem
  clientVersion: LocalStorageItem
  kilobytesSavedToday: LocalStorageItem
  haid: LocalStorageItem
  huid: LocalStorageItem
}

// This method returns an object referencing all the client values
// used when using web implementation of client.
export const getDeviceApiWebValues = (config?: Partial<DeviceApiWebValuesStorage>) => ({
  clientName:
    config?.clientName ?? new LocalStorageItem('deviceApiWeb-clientType', _DEFAULT_CLIENT_NAME),
  walletAddress: config?.walletAddress ?? new LocalStorageItem('deviceApiWeb-walletAddress'),
  isDefaultBrowser:
    config?.isDefaultBrowser ??
    new LocalStorageItem('deviceApiWeb-isDefaultBrowser', _DEFAULT_IS_DEFAULT_BROWSER),
  clientLocalization:
    config?.clientLocalization ??
    new LocalStorageItem('deviceApiWeb-clientLocalization', _DEFAULT_CLIENT_LOCALIZATION),
  clientVersion:
    config?.clientVersion ??
    new LocalStorageItem('deviceApiWeb-clientVersion', _DEFAULT_CLIENT_VERSION),
  kilobytesSavedToday:
    config?.kilobytesSavedToday ??
    new LocalStorageItem('deviceApiWeb-kilobytesSavedToday', _DEFAULT_KILOBYTES_SAVED_TODAY),
  haid: config?.haid ?? new LocalStorageItem('deviceApiWeb-haid', _DEFAULT_HAID),
  huid: config?.huid ?? new LocalStorageItem('deviceApiWeb-huid', _DEFAULT_HUID)
})
